require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.0@core-js/library/fn/object/get-prototype-of.js
// module id = 425
// module chunks = 0 1